<script setup lang="ts">
/**
 * Brand logo — dark/light pair switched by data-theme via CSS.
 * Reuses legacy auth-gate logo classes so theme switching is identical.
 */
withDefaults(defineProps<{ alt?: string }>(), { alt: 'Логотип компании' });
</script>

<template>
  <div
    class="auth-gate__logo"
    :aria-label="alt"
  >
    <img
      class="auth-gate__logo-img auth-gate__logo-img--dark"
      src="/assets/swwhite.svg"
      alt=""
    />
    <img
      class="auth-gate__logo-img auth-gate__logo-img--light"
      src="/assets/swblack.svg"
      alt=""
    />
    <span
      class="auth-gate__logo-mark"
      aria-hidden="true"
    >TM</span>
  </div>
</template>
